import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

const NothingIcon = props => <SvgIcon {...props} />

export default NothingIcon
